import Vue from 'vue'
import Router from 'vue-router'
import Cookie from 'js-cookie';

import NewUser from '@/components/NewUser'
import SignIn from '@/components/SignIn'
import Dashboard from '@/components/Dashboard'
import Account from '@/components/Account'
import Services from '@/components/Services'
import ModuleOverview from '@/components/ModuleOverview'
import ModuleQuestionnaire from '@/components/ModuleQuestionnaire'
import ModuleReport from '@/components/ModuleReport'
import SubmittedQuestionnaire from '@/components/SubmittedQuestionnaire'
import Listings from '@/components/Listings'
import NotFound from '@/components/404'
import Benchmarking from '@/components/Benchmarking'
import StandAloneSurvey from '@/components/StandAloneSurvey'

const ListingDetail = () =>
    import ('@/components/ListingDetail')
const ListingDetailAsPdf = () =>
    import ('@/components/ListingDetailAsPdf')
const HowToExpressInterest = () =>
    import ('@/components/HowToExpressInterest')

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
    // console.log(to)
    if ( Cookie.get('token') ) {
        if (to.name === undefined) {
            // if (to.path.includes('pdf/')) {
            //     const listingId = to.path.split('/').pop()
            //     window.location = `https://srg-api-prd.herokuapp.com/api/listing-details-pdf/${listingId}`;

            // } else {
                next('/page_not_found')
            //}
        } else {
            //console.log('page not found: next')
            if (to.path.includes('listing_not_found') ) {
                next('/buyer_listings')
            }
            next()
        }
        return
    } else {
        if( to.path != '/' ) {
            next(`/login?redirect=${to.path}`)

        } else {
            next('/login')
        }
    }
}
const ifNotAuthenticated = (to, from, next) => {
    if ( !Cookie.get('token') ) {
        next()
        return
    }
    next()
}

export default new Router({
    mode: 'history',
    routes: [
        {
            path: "/newuser/:data",
            name: "newuser",
            component: NewUser,
            props: true,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: "/survey/:sid",
            name: "survey",
            component: StandAloneSurvey,
            props: true,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: `/login`,
            name: "login",
            component: SignIn,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: "/dashboard",
            name: "dashboard",
            component: Dashboard,
            beforeEnter: ifAuthenticated,
        },
        {
            path: "/account",
            name: "account",
            component: Account,
            beforeEnter: ifAuthenticated,
        },
        {
            path: "/services",
            name: "services",
            component: Services,
            beforeEnter: ifAuthenticated,
        },
        {
            path: "/module_questionnaire/:mid/:pid",
            name: "module_questionnaire",
            component: ModuleQuestionnaire,
            meta: {
                title: `Module Questionnaire`
            },
            props: true,
            beforeEnter: ifAuthenticated,
        },
        {
            path: "/module_report/:mid/:pid",
            name: "module_report",
            component: ModuleReport,
            meta: {
                title: `Module Report`
            },
            props: true,
            beforeEnter: ifAuthenticated,
        },
        {
            path: "/module_resolution/:mid/:pid",
            name: "module_resolution",
            component: ModuleQuestionnaire,
            props: true,
            beforeEnter: ifAuthenticated,
        },
        {
            path: "/module_roadmap/:mid/:pid",
            name: "module_roadmap",
            component: ModuleOverview,
            meta: {
                title: `Module Overview`
            },
            props: true,
            beforeEnter: ifAuthenticated,
        },
        {
            path: "/submitted_questionnaire/:mid/:pid",
            name: "submitted_questionnaire",
            component: SubmittedQuestionnaire,
            meta: {
                title: "Submitted Questionnaire"
            },
            props: true,
            beforeEnter: ifAuthenticated,
        },
        {
            path: "/buyer_listings",
            name: "buyer_listings",
            component: Listings,
            meta: {
                title: "Buyer Listings"
            },
            beforeEnter: ifAuthenticated,
        },
        {
            path: "/buyer_listings/:lid",
            name: "listing_detail",
            component: ListingDetail,
            props: true,
            beforeEnter: ifAuthenticated,
        },
        {
            path: "/buyer_listings/:id/pdf",
            name: 'ListingDetailAsPdf',
            component: ListingDetailAsPdf,
            props: true,
        },
        {
            path: "/how_to_express_interest/:mid",
            name: 'HowToExpressInterest',
            component: HowToExpressInterest,
            props: true,
        },
        {
            path: "/benchmarking",
            name: 'benchmarking',
            component: Benchmarking,
            meta: {
                title: "Benchmarking"
            },
            beforeEnter: ifAuthenticated,
        },
        {
            path: "/page_not_found",
            component: NotFound
        },
        {
            path: "/*",
            beforeEnter: ifAuthenticated,
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js